const dlc = {
    /**Single product add/edit component tree */
    single: {
        label_code: 'Barcode',
        label_cover: 'Main image',
        label_video: 'Video',
        label_slide: 'Carousel Picture',
        label_inst_cpy: 'Copy to all following sku',
        msg_main_invalid: 'Please fill in the product information completely',
        msg_invalid_sku: 'Please complete the sku input',
        msg_noH5: 'Please fill in product details',
        msg_noEditBase: 'Don\'t submit without adding a single product',
        msg_input_invalid: 'Please fill in the input box in the single product',
        msg_input_negative: 'The input in a single product cannot be negative',
        msg_single_invalid: 'Please add at least one valid single product',
        msg_noPicture: 'Please complete the main picture and carousel picture of all single products',
        dlg_warn: 'Warning',
        dlg_reset_confirm: 'This operation will delete all product information, do you want to continue?',
        dlg_confirm: 'OK',
        dlg_cancel: 'Cancel',
        th_name: 'Product name',
        th_detail: 'Product details',
        th_origin: 'Original price',
        th_img: 'Picture',
        th_video: 'Video',
        th_offshore: 'Overseas inventory',
        th_min: 'Min count',
        th_fee: 'Operation fee ฿',
        th_offline: 'Offline SRP฿',
        th_dropship: 'Pro Price฿',
        th_credit: 'Plus Price฿',
        th_cash: 'Starter Price฿',
        th_fans: 'Fans Price฿',
        th_vip: 'VIP Price฿',
        th_sku: 'Sku code',
        th_stock: 'Stock',
        th_length: 'Length (mm)',
        th_width: 'Width (mm)',
        th_height: 'Height (mm)',
        th_weight: 'Weight (g)',
        th_isbig: 'Is it big?',
        th_transcost: 'Single piece freight ฿',
        th_alone: 'Split order',
        create: {
            title_view_detail: 'View product details',
            titel_view_image: 'View image',
            title_view_video: 'View video',
            input_copy: 'Copy',
            msg_copy_name: 'The product name has been copied to the input box',
            msg_copy_desc: 'The product details have been copied to the input box',
            msg_copy_imgs2: 'Image has been copied',
            msg_copy_imgs1: 'Valid images have been copied',
            msg_copy_imgs0: 'There is no default picture, the operation has been cancelled',
            oper_commit: 'Submit',
            oper_reset: 'Reset',
        },
        edit: {
            label_state: 'Product status',
            oper_commit: 'Submit',
        },
        searcher: {
            th_img: 'Picture',
            th_barcode: 'Barcode',
            th_name: 'Product name',
            th_stock: 'Stock',
            th_dprice: 'B2C Daily Price',
            th_oper: 'Operation',
            oper_add: 'Add',
            oper_commit: 'Submit',
            oper_reset: 'Reset',
            oper_always_down: 'Duplicated'
        },
        mainInput: {
            msg_copy_vid1: 'Video has been copyed',
            msg_copy_vid0: 'No default video, the operation has been canceled',
        }
    },

    //Paging
    pagination: {
        label_total: 'Total {0} number per page',
    },

    propSet: {
        label_name: 'name',
        label_name_plus: 'option+',
        label_option: 'item',
        label_option_plus: 'item+',
    },

    /**channel目录 */
    channel: {
        save: 'Save',
        edit: 'Edit',
        confirm: 'Confirm',
        cancel: 'Cancel',
        //Commission page
        commission: {
            daylyIncUser: 'Today\'s New recommended users',
            daylyIncOrderAmount: 'Today\'s new order amount (฿)',
            daylyIncOrderCount: 'Today\'s new orders',
            daylyIncCommission: 'New Commission today (฿)',
            weekInc: 'Newly added in the last 7 days',
            monthInc: 'Newly added in the last 30 days',
            totalInc: 'Total new additions',
            unsettledAmount: 'Commission pending settlement ({0} {day, 0} completed) (฿)',
            cleared: '{0} has settled commission',
            totalCleared: 'Total settled commission',
            browseMore: 'View Details>>',
            setting: 'Settings',
            name: 'Channel Name',
            commission: 'Commission Settings',
            settle: 'Settlement Cycle',
            settle_month: '{orderNum, 0} per month',
            qrc: 'QR code',
            unit_day: 'day(s)',
            waitSettle: 'Pending settlement',
            toSettle: 'Go to settlement',
            settled: 'Settled',
            total: 'All orders',
            handling: 'Order in progress',
            finished: 'Order has been completed',
            unsettled: 'Order to be settled',
        }
    },

    _f: {
        //英语用于表示序号的数字,即1st,2nd,3rd,4th
        orderNum(date) {
            if (typeof date === 'number' || typeof date === 'string') {
                date = parseInt(date);

                if (date === 0) {
                    return date;
                }

                if (date === 11 || date === 12) {
                    return date + 'th'
                }

                switch (date % 10) {
                    case 1:
                        return date + 'st';
                    case 2:
                        return date + 'nd';
                    case 3:
                        return date + 'rd';
                    default:
                        return date + 'th';
                }
            }
            return date
        },
        //单词day的复数形式
        day(day) {
            if (typeof day === 'number' || typeof day === 'string') {
                day = parseInt(day);

                if (day > 1) {
                    return 'days';
                }
            }

            return 'day';
        }
    },
    
    mediaInputs: {
        up_error: 'An error occurred while uploading',
        size_error: 'Do not upload empty files',
        img: {
            type_error: 'Please pass in the picture!'
        },
        pdf: {
            type_error: 'Please import the PDF file!'
        },
        video: {
            type_error: 'Please pass in the video!'
        }
    },
}

//backup
// const dlc = {
//     /**Single product add/edit component tree */
//     single: {
//         label_code: 'Barcode',
//         label_cover: 'Main image',
//         label_video: 'Video',
//         label_slide: 'Carousel Picture',
//         label_inst_cpy: 'One-click copy to all the following sku',
//         msg_main_invalid: 'Please fill in the product information completely',
//         msg_noH5: 'Please fill in product details',
//         msg_noEditBase: 'Don\'t submit without adding a single product',
//         msg_single_invalid: 'Please add at least one valid single product',
//         msg_noPicture: 'Please complete the main picture and carousel picture of all single products',
//         th_name: 'Product name',
//         th_detail: 'Product details',
//         th_origin: 'Original price',
//         th_img: 'Picture',
//         th_video: 'Video',
//         th_offshore: 'Overseas inventory',
//         th_min: 'Min count',
//         th_fee: 'Operation fee ฿',
//         th_offline: 'offline SRP฿',
//         th_dropship: 'Drop Ship Price฿',
//         th_credit: 'Credit Price฿',
//         th_cash: 'Cash Price฿',
//         th_stock: 'Stock',
//         th_length: 'Length (cm)',
//         th_width: 'Width (cm)',
//         th_height: 'Height (cm)',
//         th_weight: 'weight (g)',
//         th_isbig: 'Is it big?',
//         th_transcost: 'Single piece freight ฿',
//         create: {
//             title_view_detail: 'View product details',
//             titel_view_image: 'View image',
//             title_view_video: 'View video',
//             input_copy: 'copy',
//             msg_copy_name: 'The product name has been copied to the input box',
//             msg_copy_desc: 'The product details have been copied to the input box',
//             msg_copy_imgs2: 'Image has been copied',
//             msg_copy_imgs1: 'Valid images have been copied',
//             msg_copy_imgs0: 'There is no default picture, the operation has been cancelled',
//             msg_copy_vid1: 'Video has been copied',
//             msg_copy_vid0: 'There is no default video, the operation has been cancelled',
//             oper_commit: 'Submit',
//             oper_reset: 'Reset',
//         },
//         edit: {
//             th_origin: 'Original price',
//             th_normal: 'daily price',
//             th_discount: 'Discount price',
//             th_flash: 'Flash Price',
//             th_mega: 'Activity price',
//             th_vip: 'vip price',
//             th_barcode: 'Barcode',
//             th_skucode: 'SKUcode',
//             th_stock: 'Inventory',
//             label_state: 'Product status',
//             oper_commit: 'Submit',
//         },
//         searcher: {
//             th_img: 'Picture',
//             th_barcode: 'Barcode',
//             th_name: 'Product name',
//             th_stock: 'Stock',
//             th_dprice: 'B2C Daily Price',
//             th_oper: 'Operation',
//             oper_add: 'Add',
//             oper_commit: 'Submit',
//             oper_reset: 'Reset',
//         }
//     },

//     //Paging
//     pagination: {
//         label_total: 'Total {0} number per page',
//     },

//     propSet: {
//         label_name: 'name',
//         label_name_plus: 'option+',
//         label_option: 'item',
//         label_option_plus: 'item+',
//     }
// }

export default { dlc };
